export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'ES',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/es-es#brand`,
    'name': 'Timberland',
    'description': 'Timberland es una marca destinada a personas audaces. Nuestra misión consiste en inspirar y equipar a los aventureros más activos para que salgan fuera, trabajen duro juntos y contribuyan a que el mundo avance.',
    'url': `https://${host}/es-es`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '900.816.754',
      'contactType': 'Telephone',
      'areaServed': 'ES',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 08:30-17:00 CEST'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'ES',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 08:30-17:00 CEST',
      'url': `https://${host}/es-es`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/es-es`
})
